import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const PostTrackAccess = (moduleId, moduleName, userId, projects = null) =>
	AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Analytics/TrackAccess`,
		data: { moduleId, moduleName, userId, project: projects }  // 'project' maps to DTO Project field
	});

export const GetDashboardData = (days = 21, topN = 10) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetDashboardData`,
		params: { days, topN }
	});

export const GetFilteredData = (days = 21, topN = 10, moduleId = null, userId = null, roleId = null, projectName = null) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetDashboardData`,
		params: {
			days, topN,
			...(moduleId    && { moduleId }),
			...(userId      && { userId }),
			...(roleId      && { roleId }),
			...(projectName && { projectName }),
		}
	});

export const GetHourlyByDate = (date, moduleId = null, userId = null, roleId = null, projectName = null) =>
	AxiosRequest({
		method: 'GET',
		url: `${config.API_URL}Analytics/GetHourlyByDate`,
		params: {
			date,
			...(moduleId    && { moduleId }),
			...(userId      && { userId }),
			...(roleId      && { roleId }),
			...(projectName && { projectName }),
		}
	});

export const GetRoles = () =>
	AxiosRequest({ method: 'GET', url: `${config.API_URL}Analytics/GetRoles` });

export const GetProjects = () =>
	AxiosRequest({ method: 'GET', url: `${config.API_URL}Analytics/GetProjects` });